export function KMark({ size = 28 }) {
  // Standalone architectural K with one precision cut
  const s = size;
  return (
    <svg width={s} height={s} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-label="KUTZ" data-testid="kutz-mark">
      <rect x="8" y="6" width="8" height="52" fill="#C5A059" />
      <path d="M16 32 L46 6 L58 6 L28 34 L58 58 L46 58 L16 34 Z" fill="#C5A059" />
      <rect x="34" y="18" width="18" height="2" transform="rotate(-40 34 18)" fill="#0A0A0A" />
    </svg>
  );
}
